export class PackageConfigInfo {
  public SupportLink: string;
  public RNDirectSalesPhoneNumber: string;
  public ProseriesLacerteSalesNumber: string;
  public IntuitSalesNumber: string;
  public TechnicalSupportPhoneNumber: string;
}
